module.exports = __webpack_public_path__ + "img/yj.4a72f489.png";